import Image from 'next/image';
import { FunctionComponent } from 'react';

import icon from './contact-us.svg';

const ContactUsIcon: FunctionComponent<RewindIconsProps> = (props) => {
  const { className, alt = '' } = props;

  return (
    <Image
      className={className}
      priority
      src={icon}
      alt={alt}
    />
  );
};

export default ContactUsIcon;
